/** name → URL-safe slug. TemplateEditor 규칙과 동일(한글 보존). */
export function toSlug(name: string): string {
  return name.toLowerCase()
    .replace(/[^a-z0-9가-힣\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .slice(0, 64)
}
